export class GetAppointmentRef {
    phoneNumber: string = '';

    email: string = '';
}

interface GetAppointmentRefFormOwnProps {
    model: GetAppointmentRef;
    onSuccess: (model: GetAppointmentRef) => void;
}

export type GetAppointmentRefFormProps = GetAppointmentRefFormOwnProps;
